import { actionTypes } from '../actions/newsletter'

const initial = {
	list: [],
  current_page: '',
  last_page: '',
  total: '',
  noteDetail: '',
  newsletterDetail: '',
  year: '',
  month: '',
  notes: '',
  dates: '',
  sectors: [],
	sector: '',
	loading: false
}

export default (state = initial, action) => {
  switch (action.type) {

  	case actionTypes.RECEIVE_NEWSLETTER:
      return Object.assign({}, state, {
        list: action.data.data,
        current_page: action.data.current_page,
        last_page: action.data.last_page,
        total: action.data.total,
        loading: false
    })

    case actionTypes.RECEIVE_NOTE_DETAIL:
      return Object.assign({}, state, {
        noteDetail: action.data
    })

    case actionTypes.RECEIVE_SECTOR_NEWSLETTER:
      var sectorList = (action.data) ? action.data : []
      return { ...state, list: sectorList, year: '', month: '' }

    case actionTypes.SAVE_NEWSLETTER_DETAIL:
      return Object.assign({}, state, {
        newsletterDetail: action.data
    })

    case actionTypes.SET_YEAR:
      return { ...state, year: action.value, sector: '' }

    case actionTypes.SET_MONTH:
      return { ...state, month: action.value, sector: '' }

		case actionTypes.SET_SECTOR:
			return { ...state, sector: action.value, year: '', month: '' }

    case actionTypes.RECEIVE_FILTERED_NEWLETTERS:
      return Object.assign({}, state, {
        list: action.data.data,
        current_page: action.data.current_page,
        last_page: action.data.last_page,
        total: action.data.total,
    })

    case actionTypes.RECEIVE_NOTES:
      return Object.assign({}, state, {
        notes: action.data
    })

    case actionTypes.RECEIVE_DATES:
      return Object.assign({}, state, {
        dates: action.data
    })

    case actionTypes.RECEIVE_SECTORS:
      return Object.assign({}, state, {
        sectors: action.data.data
    })

    case actionTypes.LOADING_NEWSLETTERS:
      return Object.assign({}, state, {
        loading: true
      })

  	default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/newsletter.js